import React, { useState } from 'react';
import { FaPlus } from "react-icons/fa6";
import { IoArrowUndoSharp } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { IoIosSearch } from "react-icons/io";


const AddApplication = () => {
  const [statuses, setStatuses] = useState(['']);

  const handleAddStatus = () => {
    setStatuses([...statuses, '']);
  };

  const handleStatusChange = (index, value) => {
    const updatedStatuses = [...statuses];
    updatedStatuses[index] = value;
    setStatuses(updatedStatuses);
  };

 const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const startYear = 2000;
  const endYear = new Date().getFullYear();
  const years = [];

  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }

  const [selected, setSelected] = useState(null);

  return (
    <div className="container py-4">
         {/* Add Application */}
        <div className='d-flex align-items-center justify-content-center'>
            <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
             Add Application
           </div>
        </div>
         <div className="card mb-4 shadow-sm">
           
           <div className="card-body row">
             <div className="mb-3 col-md-12 col-12">
               <label>Student reference No</label>
               <div className='row'>
                   <div className='col-md-8'>
               <input type="text" className="form-control" />
                   </div>
                <div className='col-md-2'>
               <button className='btn btn-primary btn-lg d-flex align-items-center justify-content-center w-100'><IoIosSearch size={25} /> &nbsp; Search</button>
                   </div>
               </div>
             </div>
               
           
           </div>
         </div>
        {/* Add Application */}
   
   
   
   {/* Course Information */}
    <div className='d-flex align-items-center justify-content-center'>
            <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
             Course Information
           </div>
        </div>
         <div className="card mb-4 shadow-sm">
           
           <div className="card-body row">
             <div className="mb-3 col-md-6 col-12">
               <label>Source of Lead</label>
               <select className="form-control">
                 <option>Front Office</option>
                 <option>Website</option>
                 
               </select>
             </div>
                <div className="mb-3 col-md-6 col-12">
               <label>Application Fee Amount</label>
               <input type="text" className="form-control" />
             </div>
             <div className="mb-3 col-md-6 col-12">
               <label>Currency</label>
              <select className="form-control">
                 <option>USD</option>
                 <option>EURO</option>           
               </select>
             </div>
              <div className="mb-3 col-md-6 col-12">
               <label>Payment Method</label>
               <select className="form-control">
                 <option>Cash</option>
                 <option>Card</option>
                 <option>Bank Transfer</option>              
               </select>
             </div>
             <div className="mb-3 col-md-6 col-12">
               <label>Refrence Number</label>
                <input type="text" className="form-control" />
             </div>
              <div className="mb-3 col-md-6 col-12">
               <label>Payment Date</label>
              <input type="text" className="form-control" />
             </div>
     <div className="mb-3 col-md-6 col-12">
               <label>Remarks</label>
                <input type="text" className="form-control" />
             </div>
              <div className="mb-3 col-md-6 col-12">
               <label>Scholarship</label>
              <input type="text" className="form-control" />
             </div>
           <div className="mb-3 col-md-6 col-12">
               <label>Upload copy of Proof</label>
                <input type="file" className="form-control" />
             </div>
              <div className="mb-3 col-md-6 col-12">
               <label>Country</label>
               <select className="form-control">
                 <option>Uk</option>
                 <option>USA</option>         
               </select>
             </div>
   
               <div className="mb-3 col-md-6 col-12">
               <label>Institute</label>
              <select className="form-control">
                 <option>Institute 1</option>
                 <option>Institute 2</option>         
               </select>
             </div>
           <div className="mb-3 col-md-6 col-12">
               <label>Course</label>
              <select className="form-control">
                 <option>Course 1</option>
                 <option>Course 2</option>         
               </select>
             </div>
       <div className="mb-3 col-md-12 col-12">
               <label>Intake</label>
               <div className='row'>
                 <div className='col-md-6'>
    <select className="form-control">
                 <option disabled selected>Select Month</option>
                 <option>January</option>  
                  <option>February</option>   
                   <option>March</option>   
                    <option>April</option>   
                     <option>May</option>   
                      <option>June</option>   
                       <option>July</option>   
                        <option>August</option>   
                         <option>September</option>   
                          <option>October</option>   
                           <option>November</option>   
                            <option>December</option>          
               </select>
                 </div>
                   <div className='col-md-6'>
     <select className="form-control" defaultValue="">
         <option value="" disabled selected>Select Year</option>
         {years.map((year) => (
           <option key={year} value={year}>
             {year}
           </option>
         ))}
       </select>
                 </div>
               </div>
             
   
              
             </div>
           
   
           </div>
         </div>
   {/* Course Information */}
   
   
   {/* Personal Information */}
    <div className='d-flex align-items-center justify-content-center'>
            <div className="fs-2 w-50 mb-2 text-center bg-dark text-white">
             Personal Information
           </div>
        </div>
         <div className="card mb-4 shadow-sm">
           
           <div className="card-body row">
             <div className="mb-3 col-md-6 col-12">
               <label>Gender</label>
               <select className="form-control">
                 <option>Male</option>
                 <option>Female</option>
                 
               </select>
             </div>
                <div className="mb-3 col-md-6 col-12">
               <label>Title</label>
               <input type="text" className="form-control" />
             </div>
             <div className="mb-3 col-md-6 col-12">
               <label>First Name</label>
             <input type="text" className="form-control" />
             </div>
              <div className="mb-3 col-md-6 col-12">
               <label>Last Name</label>
              <input type="text" className="form-control" />
             </div>
             <div className="mb-3 col-md-6 col-12">
               <label>Date of Birth</label>
                <input type="date" className="form-control" />
             </div>
              <div className="mb-3 col-md-6 col-12">
               <label>Martial Status</label>
              <select className="form-control">
                 <option>Married</option>
                 <option>Unmarried</option>
                  <option>Divorced</option>
                   <option>Single</option>
                   <option>Widowed</option>
               </select>
             </div>
     <div className="mb-3 col-md-6 col-12">
               <label>Nationality</label>
                <input type="text" className="form-control" />
             </div>
              <div className="mb-3 col-md-6 col-12">
           <div className="passport-container">
         <label className="question">Do You Have Valid Passport</label>
         <div className="button-group">
           <button
             className={`toggle-btn w-100 ${selected === 'yes' ? 'selected' : ''}`}
             onClick={() => setSelected('yes')}
           >
             Yes
           </button>
           <button
             className={`toggle-btn w-100 ${selected === 'no' ? 'selected' : ''}`}
             onClick={() => setSelected('no')}
           >
             No
           </button>
         </div>
       </div>
             </div>
           <div className="mb-3 col-md-6 col-12">
               <label>Passport</label>
                <input type="text" className="form-control" />
             </div>
              <div className="mb-3 col-md-6 col-12">
               <label>Mobile No</label>
               <div className='row'>
                 <div className='col-md-6 col-3'>
                   <input type="text" placeholder='C code' className="form-control" />
                 </div>
                  <div className='col-md-6 col-9'>
                   <input type="text" placeholder='Number' className="form-control" />
                  </div>
               </div>
             </div>
   
               <div className="mb-3 col-md-6 col-12">
               <label>E-mail</label>
             <input type="email" className="form-control" />
             </div>
           <div className="mb-3 col-md-6 col-12">
               <label>Skype ID</label>
             <input type="text" className="form-control" />
             </div>
       <div className="mb-3 col-md-12 col-12">
               <label>Application Image</label>
                 <input type="file" className="form-control" />
             </div>
           
   
           </div>
         </div>
   {/* Personal Information */}
   
   {/* Payment Information */}
   <div className='row'>
         <div className='col-md-6'>
   <div className='d-flex align-items-center justify-content-center'>
            <div className="fs-4 p-2 mb-2 text-center bg-dark text-white">
             Payment Address
           </div>
        </div>
        <div className="card mb-4 shadow-sm">
           
           <div className="card-body row">
            
                <div className="mb-3 col-md-12 col-12">
               <label>Address</label>
               <input type="text" className="form-control" />
             </div>
             <div className="mb-3 col-md-12 col-12">
               <label>City</label>
             <input type="text" className="form-control" />
             </div>
              <div className="mb-3 col-md-12 col-12">
               <label>State</label>
              <input type="text" className="form-control" />
             </div>
             <div className="mb-3 col-md-12 col-12">
               <label>Select Country</label>
                <select className='form-control'>
                 <option>UK</option>
                  <option>USA</option>
                </select>
             </div>
              <div className="mb-3 col-md-12 col-12">
               <label>Pin/Zip/Postal Code</label>
               <input type="text" className="form-control" />
             </div>
           </div>
         </div>
         </div>
            <div className='col-md-6'>
   <div className='d-flex align-items-center justify-content-center'>
            <div className="fs-4  p-2 mb-2 text-center bg-dark text-white">
             Correspondence Address
           </div>
        </div>
         <div className="card mb-4 shadow-sm">
           
           <div className="card-body row">
            
                <div className="mb-3 col-md-12 col-12">
               <label>Address</label>
               <input type="text" className="form-control" />
             </div>
             <div className="mb-3 col-md-12 col-12">
               <label>City</label>
             <input type="text" className="form-control" />
             </div>
              <div className="mb-3 col-md-12 col-12">
               <label>State</label>
              <input type="text" className="form-control" />
             </div>
             <div className="mb-3 col-md-12 col-12">
               <label>Select Country</label>
               <select className='form-control'>
                 <option>UK</option>
                  <option>USA</option>
                </select>
             </div>
              <div className="mb-3 col-md-12 col-12">
               <label>Pin/Zip/Postal Code</label>
               <input type="text" className="form-control" />
             </div>
           </div>
         </div>
         </div>
   </div>
   {/* Payment Information */}
   
   
   
   
   <div className='card mb-4 shadow-sm'>
         <div className='card-body row'>
   
            <div className="accordion" id="educationAccordion">
     <div className="accordion-item">
       <h2 className="accordion-header ">
         <button className="accordion-button bg-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseEducation" aria-expanded="true" aria-controls="collapseEducation">
           Education & English Language
         </button>
       </h2>
       <div id="collapseEducation" className="accordion-collapse collapse show" data-bs-parent="#educationAccordion">
           <div className="accordion-body">
           <div className="container my-4">
         {/* My Education Section */}
         <h5 className="mb-2">My Education</h5>
         <p className="mb-3 text-muted">Please List Your Qualification Taken With The Most Recent First</p>
    
         <div className="row mb-3">
             <div className="col-md-3 mb-2">
              <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary'>
                 Name Of Institution
               </div>
               <input type="text" className="form-control" placeholder="" />
                <input type="text" className="form-control mt-2" placeholder="" />
                 <input type="text" className="form-control mt-2" placeholder="" />
             </div>
             <div className="col-md-2 mb-2">
               <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary'>
                 Qualification
               </div>
             <input type="text" className="form-control" placeholder="" />
                <input type="text" className="form-control mt-2" placeholder="" />
                 <input type="text" className="form-control mt-2" placeholder="" />
             </div>
             <div className="col-md-2 mb-2">
                <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary'>
                 Year Of Passing
               </div>
               <input type="text" className="form-control" placeholder="" />
                <input type="text" className="form-control mt-2" placeholder="" />
                 <input type="text" className="form-control mt-2" placeholder="" />
             </div>
             <div className="col-md-2 mb-2">
               <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary'>
                 Grade
               </div>
               <input type="text" className="form-control" placeholder="" />
                <input type="text" className="form-control mt-2" placeholder="" />
                 <input type="text" className="form-control mt-2" placeholder="" />
             </div>
               
             <div className="col-md-3 mb-2">
               <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary'>
                 Scanned Copy
               </div>
               <input type="file" className="form-control" placeholder="" />
                <input type="file" className="form-control mt-2" placeholder="" />
                 <input type="file" className="form-control mt-2" placeholder="" />
             </div>
           </div>
          
   
         {/* English Language & Other Entry Form */}
         <h5 className="mt-5 mb-2">English Language & Other Entry Form</h5>
         <p className="mb-3 text-muted">Please List Your Qualification Taken With The Most Recent First</p>
   
         <div className="row text-center mb-3">
          
             <div className="col-md-3 col-12 " >
               <div className="bg-primary text-center p-2 text-white mb-2 rounded w-100"><input type='checkbox'/> IELTS</div>
                   <div className="mb-2 text-start">
                     <label>Listening</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Reading</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Writing</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Speaking</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Overall Score</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Date</label>
                     <input type="date" className="form-control"/>
                   </div>
                    <div className="mb-2 text-start">
                     <label>Scanned Copy</label>
                      <input type="file" className="form-control" />
                   </div>
                  
             </div>
             <div className="col-md-3 col-12" >
               <div className="bg-primary text-center p-2 text-white rounded w-100"><input type='checkbox'/> TOEFL</div>
                  <div className="mb-2 text-start">
                     <label>Listening</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Reading</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Writing</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Speaking</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Overall Score</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Date</label>
                     <input type="date" className="form-control"/>
                   </div>
                    <div className="mb-2 text-start">
                     <label>Scanned Copy</label>
                      <input type="file" className="form-control" />
                   </div>
                  
             </div>
             <div className="col-md-3 col-12" >
               <div className="bg-primary text-center p-2 text-white rounded w-100"><input type='checkbox'/> PTE</div>
                  <div className="mb-2 text-start">
                     <label>Listening</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Reading</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Writing</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Speaking</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Overall Score</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Date</label>
                     <input type="date" className="form-control"/>
                   </div>
                    <div className="mb-2 text-start">
                     <label>Scanned Copy</label>
                      <input type="file" className="form-control" />
                   </div>
                  
             </div>
             <div className="col-md-3 col-12" >
               <div className="bg-primary text-center p-2 text-white rounded w-100"><input type='checkbox'/> GMAT</div>
                  <div className="mb-2 text-start">
                     <label>Listening</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Reading</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Writing</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Speaking</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Overall Score</label>
                     <input type="text" className="form-control"/>
                   </div>
                   <div className="mb-2 text-start">
                     <label>Date</label>
                     <input type="date" className="form-control"/>
                   </div>
                    <div className="mb-2 text-start">
                     <label>Scanned Copy</label>
                      <input type="file" className="form-control" />
                   </div>
                  
             </div>
              <div className="col-md-12 col-12" >
               <div className="bg-primary text-center p-2 text-white rounded w-100"><input type='checkbox'/> Other</div>
               <textarea className='form-control mt-2'></textarea>
                <div className="mb-2 text-start">
                     <label>Scanned Copy</label>
                      <input type="file" className="form-control" />
                   </div>
             </div>
         </div>
   
       
       </div>
   
         </div>
       </div>
     </div>
   </div>
   
   
   
   
   
   
   
        <div className="accordion mt-4" id="workexpereince">
     <div className="accordion-item">
       <h2 className="accordion-header ">
         <button className="accordion-button bg-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseWork" aria-expanded="true" aria-controls="collapseWork">
           Work Experience & Academic Reference
         </button>
       </h2>
       <div id="collapseWork" className="accordion-collapse collapse show" data-bs-parent="#workexpereince">
          <div className="accordion-body">
           <div className="container my-4">
         {/* My Employer Section */}
         <h5 className="mb-2">Work Experience</h5>
         <p className="mb-3 text-muted">Please list your Experience taken with the most recent first</p>
    
         <div className="row mb-3">
             <div className="col-md-3 mb-2">
              <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary'>
                 Name of Employer
               </div>
               <input type="text" className="form-control" placeholder="" />
                <input type="text" className="form-control mt-2" placeholder="" />
                 <input type="text" className="form-control mt-2" placeholder="" />
             </div>
             <div className="col-md-2 mb-2">
               <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary'>
                 Position
               </div>
              <input type="text" className="form-control" placeholder="" />
                <input type="text" className="form-control mt-2" placeholder="" />
                 <input type="text" className="form-control mt-2" placeholder="" />
             </div>
             <div className="col-md-2 mb-2">
                <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary'>
                 Period
               </div>
             <input type="text" className="form-control" placeholder="" />
                <input type="text" className="form-control mt-2" placeholder="" />
                 <input type="text" className="form-control mt-2" placeholder="" />
             </div>
             <div className="col-md-2 mb-2">
               <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary' style={{fontSize:'16px'}}>
                 Responsibilities
               </div>
              <input type="text" className="form-control" placeholder="" />
                <input type="text" className="form-control mt-2" placeholder="" />
                 <input type="text" className="form-control mt-2" placeholder="" />
             </div>
               
             <div className="col-md-3 mb-2">
               <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary'>
                 Scanned Copy
               </div>
              <input type="file" className="form-control" placeholder="" />
                <input type="file" className="form-control mt-2" placeholder="" />
                 <input type="file" className="form-control mt-2" placeholder="" />
             </div>
           </div> 
          
        
   
   
   
   
   
         {/* Reference Section */}
         <h5 className="mb-2">Reference</h5>
         <p className="mb-3 text-muted">Please list your Reference taken with the most recent first</p>
    
         <div className="row text-center mb-3">
          
             <div className="col-md-6 col-12" >
               <div className="bg-primary text-center p-2 text-white mb-2 rounded w-100">Reference 01</div>
                   <div className="mb-2 text-start">
                      <input type="text" className="form-control" placeholder='Name'/>
                   </div>
                   <div className="mb-2 text-start">
                     
                     <input type="text" className="form-control"  placeholder='Designation'/>
                   </div>
                   <div className="mb-2 text-start">
                    
                     <input type="text" className="form-control"  placeholder='Institution'/>
                   </div>
                   <div className="mb-2 text-start">
                    
                     <input type="text" className="form-control"  placeholder='Email ID'/>
                   </div>
                   <div className="mb-2 text-start">
                     
                     <input type="text" className="form-control"  placeholder='Phone No'/>
                   </div>
                   <div className="mb-2 text-start">
                    
                     <input type="text" className="form-control"  placeholder='Address'/>
                   </div>
                    <div className="mb-2 text-start">
                    
                      <input type="text" className="form-control"  placeholder='City'/>
                   </div>
                    <div className="mb-2 text-start">
                    
                     <input type="text" className="form-control"  placeholder='State'/>
                   </div>
                    <div className="mb-2 text-start">
                    
                      <input type="text" className="form-control"  placeholder='Country'/>
                   </div>
                   <div className="mb-2 text-start">
                    
                      <input type="text" className="form-control"  placeholder='Zip Code'/>
                   </div>
             </div>
              <div className="col-md-6 col-12" >
               <div className="bg-primary text-center p-2 text-white mb-2 rounded w-100">Reference 02</div>
                   <div className="mb-2 text-start">
                      <input type="text" className="form-control" placeholder='Name'/>
                   </div>
                   <div className="mb-2 text-start">
                     
                     <input type="text" className="form-control"  placeholder='Designation'/>
                   </div>
                   <div className="mb-2 text-start">
                    
                     <input type="text" className="form-control"  placeholder='Institution'/>
                   </div>
                   <div className="mb-2 text-start">
                    
                     <input type="text" className="form-control"  placeholder='Email ID'/>
                   </div>
                   <div className="mb-2 text-start">
                     
                     <input type="text" className="form-control"  placeholder='Phone No'/>
                   </div>
                   <div className="mb-2 text-start">
                    
                     <input type="text" className="form-control"  placeholder='Address'/>
                   </div>
                    <div className="mb-2 text-start">
                    
                      <input type="text" className="form-control"  placeholder='City'/>
                   </div>
                    <div className="mb-2 text-start">
                    
                     <input type="text" className="form-control"  placeholder='State'/>
                   </div>
                    <div className="mb-2 text-start">
                    
                      <input type="text" className="form-control"  placeholder='Country'/>
                   </div>
                   <div className="mb-2 text-start">
                    
                      <input type="text" className="form-control"  placeholder='Zip Code'/>
                   </div>
             </div>
         </div>
   
       
       </div>
   
         </div>
       </div>
     </div>
   </div>
   
   
   
       <div className="accordion mt-4" id="purposesection">
     <div className="accordion-item">
       <h2 className="accordion-header ">
         <button className="accordion-button bg-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapsepurpose" aria-expanded="true" aria-controls="collapsepurpose">
           Statement of Purpose
         </button>
       </h2>
       <div id="collapsepurpose" className="accordion-collapse collapse show" data-bs-parent="#purposesection">
         <div className="accordion-body">
           <div className="container my-4">
         {/* My Employer Section */}
        
         <p className="mb-3 text-muted">Please upload the Documents either in a single pdf file or zip file for any additional documents that institution may require to process your application  </p>
    
         <div className="row mb-3">
             <div className="col-md-6 mb-2">
              <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary'>
                 Title
               </div>
               <input type="text" className="form-control" placeholder="" />
             </div>
             <div className="col-md-6 mb-2">
               <div className='w-100 text-center p-2 text-white rounded mb-2 bg-primary'>
                  Upload File
               </div>
               <input type="file" className="form-control" />
             </div>
           </div> 
           <div className="row mb-3">
             <div className="col-md-6 mb-2">
              
               <input type="text" className="form-control" placeholder="" />
             </div>
             <div className="col-md-6 mb-2">
               <input type="file" className="form-control" />
             </div>
            
           </div>
    <div className="row mb-3">
             <div className="col-md-6 mb-2">
              
               <input type="text" className="form-control" placeholder="" />
             </div>
             <div className="col-md-6 mb-2">
               <input type="file" className="form-control" />
             </div>
            
           </div>
   
   
       
       </div>
   
         </div>
       </div>
     </div>
   </div>
   
   
         </div>
   </div>
       
    <div className=" gap-2 pt-3 pb-3">
     <div>
       <input type='checkbox' /> By Clicking on submit you accept the terms & Conditions of submitting an application 
     </div>
     <button type="submit" className="btn btn-primary mt-3">Submit</button>
   </div>
   
       </div>
  );
};

export default AddApplication;
